export const countryCodes = [
  '+46',
  '+1',
  '+44',
];
